import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { LoginPageComponent } from './login/login-page.component';
import { LogoutPageComponent } from '../secured/logout/logout-page.component';
import { RegistrationComponent } from './registration/registration.component';
import { ConfirmRegistrationComponent } from './registration/confirm-registration/confirm-registration.component';
import { ForgotUsernameComponent } from './forgot-credentials/username/forgot-username/forgot-username.component';
import { RequestVerificationCodeComponent } from './forgot-credentials/password/request-verification-code/request-verification-code.component';
import { CreatePasswordComponent } from './forgot-credentials/password/create-password/create-password.component';
import { ForgotPasswordComponent } from './forgot-credentials/password/forgot-password.component';
import { ErrorComponent } from './error/error.component';
import { SsoSessionEndedComponent } from './sso-logout/sso-session-ended.component';
import { SetupSecurityTokenComponent } from '../secured/setup-security-token/setup-security-token.component';
import { EnterVerificationCodeComponent } from '../secured/setup-security-token/enter-verification-code/enter-verification-code.component';
import { SetMobileAppComponent } from '../secured/setup-security-token/set-mobile-app/set-mobile-app.component';
import { SetupNameComponent } from '../secured/setup-name/setup-name.component';

import { SharedModule } from '../../shared/shared.module';
import { AgentRegistrationComponent } from './registration/agent-registration/agent-registration.component';
import { PreInvitationRegistrationComponent } from '../secured/registration/pre-agent-registration/pre-invitation-registration.component';
import { SsoLoginComponent } from './sso-login/sso-login.component';
import { RegistrationSideComponent } from './login/registration-side/registration-side.component';
import { NewPublicShellComponent } from './new-public-shell/new-public-shell.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        LoginPageComponent,
        LogoutPageComponent,
        RegistrationComponent,
        ConfirmRegistrationComponent,
        ForgotUsernameComponent,
        ForgotPasswordComponent,
        CreatePasswordComponent,
        RequestVerificationCodeComponent,
        SetupSecurityTokenComponent,
        EnterVerificationCodeComponent,
        ErrorComponent,
        SetMobileAppComponent,
        AgentRegistrationComponent,
        PreInvitationRegistrationComponent,
        SsoLoginComponent,
        SetupNameComponent,
        SsoSessionEndedComponent,
        RegistrationSideComponent,
        NewPublicShellComponent,
        PrivacyPolicyComponent,
    ],
    exports: [
        NewPublicShellComponent,
        LoginPageComponent,
        LogoutPageComponent,
        RegistrationComponent,
        ConfirmRegistrationComponent,
        ForgotUsernameComponent,
        ForgotPasswordComponent,
        CreatePasswordComponent,
        RequestVerificationCodeComponent,
        SetupSecurityTokenComponent,
        SetMobileAppComponent,
        SsoLoginComponent,
        SetupNameComponent,
        EnterVerificationCodeComponent,
        ErrorComponent,
        SsoSessionEndedComponent,
    ]
})
export class PublicModule {
}
